import { Route } from '@angular/router';

export const commissionPaymentRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/commission-payment-list.component').then(
        (m) => m.CommissionPaymentListComponent
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detail/commission-payment-detail.component').then(
        (m) => m.CommissionPaymentDetailComponent
      ),
  },
];
